import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus } from '@core/typings/status.typing';
import { AwardService } from '../award.service';

@Pipe({
  name: 'gcIsPaymentAmountDisabled'
})
export class IsPaymentAmountDisabledPipe implements PipeTransform {

  constructor (
    private awardService: AwardService
  ) { }

  transform (
    isUnits: boolean,
    isExistingPayment: boolean,
    paymentStatus: PaymentStatus,
    isEditingConversion: boolean,
    isUpdatingBudget: boolean,
    budgetFsIsClosed: boolean
  ) {
    return this.awardService.getIsPaymentAmountDisabled(
      isUnits,
      isExistingPayment,
      paymentStatus,
      isEditingConversion,
      isUpdatingBudget,
      budgetFsIsClosed
    );
  }
}
